//@ts-ignore
// @ts-nocheck
import {
  applySnapshot,
  flow,
  getParent,
  getSnapshot,
  types,
} from "mobx-state-tree";
import {
  transformInput,
  transformOutput,
  generateSearchSubject,
} from "./utils/misc";
import { transformSplit } from "./utils/request-splitter";

const ChildDetail = types.model("ChildDetail", {
  class: types.optional(types.string, ""),
  purpose: types.optional(types.string, ""),
  subjects: types.optional(types.array(types.string), []),
});

export const SingleChild = types
  .model("SingleChild", {
    name: types.optional(types.string, ""),
    firstName: types.optional(types.string, ""),
    gender: types.union(
      types.optional(types.enumeration("Gender", ["male", "female"]), "male"),
      types.optional(types.string, ""),
    ),
    classDetail: types.optional(ChildDetail, {}),
    curriculum: types.optional(types.array(types.string), []),
    learningNeed: types.optional(types.string, ""),
    expectation: types.optional(types.string, ""),
    special_needs: types.union(
      types.optional(types.maybeNull(types.string), ""),
      types.optional(types.array(types.string), []),
    ),
  })
  .actions((self) => {
    return {
      updateField(data) {
        applySnapshot(self, data);
      },
    };
  });

export const ChildrenStore = types
  .model("ChildrenStore", {
    childDetails: types.optional(types.array(SingleChild), []),
  })
  .views((self) => {
    return {
      get numberOfTeachers() {
        return this.splitRequests.length;
      },
      get splitRequests() {
        let parent = getParent(self, 1);
        let _splitValue = parent.teacherSelectStore.teacherOption;
        let teacherSplitOptions = Object.values(this.teacherSplitOptions);
        if (teacherSplitOptions.length > 0 && _splitValue) {
          // let splitValue = teacherSplitOptions[0];
          let splitValue = this.teacherSplitOptions[_splitValue];

          if (splitValue) {
            let finalValue = generateSearchSubject(
              getSnapshot(self.childDetails),
              splitValue,
            );
            return finalValue;
          }
        }
        return [];
      },
      get teacherSplitOptions() {
        let transformedOutput = transformOutput({
          childDetails: getSnapshot(self.childDetails),
        });
        let result = transformSplit(transformedOutput);
        return result;
      },
      get isPopulated() {
        return self.childDetails.length > 0;
      },
      get noOfTeacherInfo() {
        let initialTeacherOption =
          this.splitRequests.length > 0
            ? this.splitRequests[0].teacherOption
            : "";

        let teacherOptions = Object.keys(this.teacherSplitOptions);
        let isOneTeacherOption = teacherOptions.length === 1;
        return {
          initialTeacherOption,
          isOneTeacherOption,
        };
      },
      get inputValue() {
        return self.childDetails.length > 0
          ? transformInput(self.childDetails)
          : "";
      },
      get fullData() {
        let childDetails = transformOutput({
          childDetails: getSnapshot(self.childDetails),
        });
        return { childDetails, splitRequests: this.splitRequests };
      },
    };
  })
  .actions((self) => {
    const onSubmitForm = flow(function* submitForm(data) {
      let parent = getParent(self, 1);
      // let transformedOutput = transformOutput(data);
      // self.childDetails = cast(transformedOutput);
      yield parent.onSubmit({ ...data, ...self.fullData });
    });
    return {
      onSubmitForm,
      addNewChild(data) {
        self.childDetails.push(data);
      },
      removeLastChild() {
        self.childDetails.pop();
      },
      replaceData(index, data) {
        self.childDetails.forEach((child, i) => {
          if (i === index) {
            applySnapshot(child, data);
          }
        });
        // self.childDetails.replace()
      },
      remove(index) {
        self.childDetails = self.childDetails.filter((x, i) => i !== index);
      },
    };
  });

export default ChildrenStore;
